import React from 'react';
import model from './model.png';
import css from './BannerSection.module.css';

const BannerSection = ({intl}) => {
  return (
    <div className={css.wrapper}>
      <div className={css.sectionLeft}>
        <p className={css.title}>
        {intl.formatMessage({ id: 'CustomBlogPage.BannerSection.heading' })}
        </p>
      </div>
      <div className={css.sectionRight}>
        <img src={model} className={css.image} />
      </div>
    </div>
  );
};

export default BannerSection;
